import React, { useState, useEffect } from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Bed, Bath, Maximize , ParkingCircle, MapPin } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import PropertyImages from '../componance/Modal/PropertyImages';

import CreatePropertyForm from '../contacts/CreatePropertyForm';
import AppointmentForm from '../contacts/AppointmentForm'
const PropertyListRent = ({ properties, openModal, favorites, toggleFavorite, currency }) => {
  const exchangeRate = 36;
  const { t } = useTranslation();
const [showFormapp, setShowFormapp] = useState(false);
  const [showForm, setShowForm] = useState(false); // 🔹 state สำหรับ modal
  const [selectedProperty, setSelectedProperty] = useState(null); // 🔹 เก็บ property ที่จะส่งไปใน form
  const formatPrice = (price) => {
    if (!price) return '-';
    if (typeof price === 'string' && /[^\d.,]/.test(price)) return price;
    const numericPrice = Number(price);
    if (isNaN(numericPrice)) return price;

    return currency === 'THB'
      ? `${numericPrice.toLocaleString()} THB / month`
      : `${(numericPrice / exchangeRate).toFixed(2)} $`;
  };
  useEffect(() => {
      if (showForm || showFormapp) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "auto";
      }
  
      // cleanup
      return () => {
        document.body.style.overflow = "auto";
      };
    }, [showForm, showFormapp]);

  // Filter properties to only include 'Rent'
  const RentProperties = properties.filter(p => p.status === 'Rent');

  const handleOpenForm = (e, property) => {
    e.stopPropagation();
    setSelectedProperty(property);
    setShowForm(true);
  };
  const handleOpenFormApp = (e, property) => {
    e.stopPropagation();
    setSelectedProperty(property);
    setShowFormapp(true);
  };

  const handleCloseForm = () => {
    setShowForm(false);
    setShowFormapp(false);
    setSelectedProperty(null);
  };

   const formatDateWithTranslate = (date, t) => {
  const d = new Date(date);
  const month = d.toLocaleString('en-EN', { month: 'long' });
  return `${t(month)} ${d.getDate()}, ${d.getFullYear()}`;
};
  return (
    <div style={styles.propertyListContainer}>
      {RentProperties.map((property) => {
        const isFavorited = favorites.some(fav => fav.property_id === property.property_id);

        let images = [];
        if (Array.isArray(property.images)) {
          images = property.images;
        } else if (typeof property.images === 'string') {
          images = property.images.replace(/^{|}$/g, '').split(',').map(img => img.trim());
        } else if (property.image) {
          images = [property.image];
        }

       return (
           <div
          key={property.property_id}
          style={{
            ...styles.propertyCard, // เอา style เดิมทั้งหมด
            width: window.innerWidth <= 480 ? '380px' : styles.propertyCard.width, // ตัวอย่างปรับ width
          }}
          onClick={() => openModal(property)}
          >
            <button
              onClick={(e) => {
                e.stopPropagation();
                toggleFavorite(property);
              }}
              style={styles.favoriteButton}
            >
              {isFavorited ? '❤️' : '🤍'}
            </button>

            <div style={styles.imageContainer}>
              <div style={styles.propertyIdWrapper}>
                <span style={styles.propertyIdText}>{t('SHA ID')}: {property.property_id}</span>
               
                    {property.featured && (
                  <span style={styles.hotDealInline}>🔥 Hot Deal</span>
                )}
                 {property.furnished && (
                  <span style={styles.furnishedInline}> {t("Furnished_full")}</span>
                )}
              </div>
              <img src="/img/logo3.png" alt="Logo" style={styles.logoUnderId} />
              <PropertyImages images={images} propertyName={property.name} />
            </div>

            <div
              style={{
                ...styles.statusBadge,
                backgroundColor:
                  property.status === 'Rent'
                    ? '#3498db'
                    : property.status === 'Rented'
                    ? '#E74C3C'
                    : '#3498db',
              }}
            >
              <div>{t(`status.${property.status}`)}</div>
            </div>

            <div style={styles.namePriceRow}>
              <div style={styles.propertyNameLeft}>
                {t(property.name)}
                {property.type && <div style={styles.propertyType}>{t(property.type)}</div>}
              </div>
             
            </div>
            <div style={styles.priceLocationRow}>
              <div style={styles.propertyPriceLeft}>{formatPrice(property.price)}</div>
              <div style={styles.propertyLoRight}>
                <MapPin size={15} /> {property.location ? t(property.location) : '-'}
              </div>
            </div>


            <div style={styles.infoOverlay}>
              <div style={styles.infoItem}>
                <Bed size={20} />
                <div>
                  {property.bedrooms > 0 ? `${property.bedrooms} ${t('Bedrooms')}` : '-'}
                </div>
              </div>
              <div style={styles.infoItem}>
                <Bath size={20} />
                <div>
                  {property.bathrooms > 0 ? `${property.bathrooms} ${t('Bathrooms')}` : '-'}
                </div>
              </div>
              <div style={styles.infoItem}>
                <ParkingCircle size={20} />
                <div>{property.parking > 0 ? `${property.parking} ${t('Parking')}` : '-'}</div>
              </div>
              <div style={styles.infoItem}>
                <Maximize size={20} />
                <div>
                  {property.buildingArea > 0
                    ? `${property.buildingArea} ${t('sq.m.')}`
                    : '-'}
                </div>
              </div>
            </div>

            {/* ✅ ส่วนท้าย เพิ่มปุ่มขอข้อมูล */}
            <div style={styles.companyInfoBar}>
            
             
              <button
                style={styles.requestButton}
                onClick={(e) => handleOpenForm(e, property)}
              >
                {t('Request Details')}
              </button>
               <button
                style={styles.requestButton}
                onClick={(e) => handleOpenFormApp(e, property)}
              >
                {t('Appointment')}
              </button>
            </div>
          {/* ✅ วันที่สร้างโพสต์ */}
          <div style={styles.createdAt}>
         {t('Posted on')}: {formatDateWithTranslate(property.created_at, t)}
             </div>


          </div>
        );
      })}

              {/* ✅ Modal สำหรับ CreatePropertyForm */}
          {showForm && (
            <div
              style={styles.modalOverlay}
              onClick={handleCloseForm} // ✅ คลิกที่พื้นหลังเพื่อปิด
            >
              <div
                style={styles.modalContent}
                onClick={(e) => e.stopPropagation()} // ✅ ป้องกันไม่ให้คลิกในกล่องแล้วปิด
              >
                <button style={styles.closeModal} onClick={handleCloseForm}>
                  ✕
                </button>
                <CreatePropertyForm property={selectedProperty} />
              </div>
            </div>
          )}

          {/* ✅ Modal สำหรับ AppointmentForm */}
          {showFormapp && (
            <div
              style={styles.modalOverlay}
              onClick={handleCloseForm} // ✅ คลิกพื้นหลังเพื่อปิด
            >
              <div
                style={styles.modalContent}
                onClick={(e) => e.stopPropagation()} // ✅ ป้องกันปิดเมื่อคลิกในเนื้อหา
              >
                <button style={styles.closeModal} onClick={handleCloseForm}>
                  ✕
                </button>
                <AppointmentForm property={selectedProperty} />
              </div>
            </div>
          )}

                
              </div>
            );
          };


const styles = {
  propertyListContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '20px',
    justifyContent: 'center',
  },
  favoriteButton: {
    position: 'absolute',
    top: '40px',
    right: '10px',
    background: 'transparent',
    border: 'none',
    fontSize: '20px',
    cursor: 'pointer',
    zIndex: 999,
  },
  createdAt: {
  fontSize: '12px',
  color: '#555',
  textAlign: 'left',
  marginTop: '4px',
  marginRight: '10px',
  fontStyle: 'italic',
},
  propertyCard: {
    position: 'relative',
    width: '320px',
    borderRadius: '8px',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.2)',
    textAlign: 'center',
    backgroundColor: '#fff',
    padding: '10px',
    cursor: 'pointer',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    height: '500px',
    transition: 'transform 0.3s ease-in-out, box-shadow 0.3s ease',
  },
    hotDealInline: { background: 'linear-gradient(135deg, #ffa733, #ff6b00, #cc5200)', color: '#fff', padding: '2px 6px', borderRadius: '6px', fontSize: '11px', fontWeight: 'bold', marginLeft: '6px' },

  imageContainer: { position: 'relative' },
 
  logoUnderId: {
    position: 'absolute',
    top: '35px',
    left: '10px',
    width: '50px',
    height: 'auto',
    zIndex: 2,
  },
  propertyId: {
    position: 'absolute',
    top: '10px',
    left: '10px',
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    color: 'white',
    padding: '4px 8px',
    fontSize: '12px',
    borderRadius: '4px',
    zIndex: 2,
    fontWeight: 'bold',
  },
  statusBadge: {
    position: 'absolute',
    top: '10px',
    right: '10px',
    color: '#fff',
    padding: '5px 10px',
    borderRadius: '0px',
    fontSize: '14px',
    fontWeight: 'bold',
  },
  priceLocationRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 10px',
    marginTop: '5px',
  },
  propertyPriceLeft: {
    fontSize: '26px',
    fontWeight: 'bold',
    color: '#2c3e50',
    textAlign: 'left',
    whiteSpace: 'nowrap',
  },
  
  namePriceRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0 10px',
    marginTop: '12px',
  },
  propertyNameLeft: {
    fontSize: '16px',
    fontWeight: '600',
    color: '#2c3e50',
    textAlign: 'left',
    flex: 1,
    whiteSpace: 'normal',
    overflow: 'visible',
    textOverflow: 'unset',
    wordBreak: 'break-word',
    fontFamily: `'Roboto Condensed', 'Kanit', sans-serif`,
  },
  furnishedInline:{ background: 'linear-gradient(90deg, #1a8cff, #0a71e7)', color: '#fff', padding: '2px 6px', borderRadius: '6px', fontSize: '11px', fontWeight: 'bold', marginLeft: '6px' },
  propertyIdWrapper: { position: 'absolute', top: '10px', left: '10px', display: 'flex', alignItems: 'center', zIndex: 2 },
  propertyIdText: { backgroundColor: 'rgba(0,0,0,0.6)', color: '#fff', padding: '4px 8px', fontSize: '12px', borderRadius: '4px', fontWeight: 'bold' },
 
  propertyType: {
    fontSize: '12px',
    color: '#888',
    fontWeight: '500',
    marginTop: '4px',
  },
  propertyPriceRight: {
    fontSize: '18px',
    fontWeight: 'bold',
    color: '#000000ff',
    textAlign: 'right',
    marginLeft: '10px',
    whiteSpace: 'nowrap',
  },
  propertyLoRight: {
   fontSize: '12px',
    fontWeight: 'bold',
    color: '#000000ff',
    textAlign: 'right',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    whiteSpace: 'nowrap',
  },
  infoOverlay: {
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    backgroundColor: 'rgba(30, 62, 93, 0.8)',
    color: '#fff',
    padding: '10px 0',
    marginTop: '-5px',
    borderRadius: '20px',
    fontSize: '13px',
    fontWeight: '500',
    marginBottom: '5px',
  },
  infoItem: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    flex: 1,
  },
  companyInfoBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: 'linear-gradient(to right, #192c43ff, #192c43ff)',
    padding: '10px',
    borderRadius: '0 0 8px 8px',
    width: '100%',
    marginLeft: '-10px',
    marginBottom: '-10px',
    gap: '10px',
  },
  companyLogo: { width: '30px', height: 'auto' },
  companyName: { fontSize: '16px', fontWeight: '600', color: '#fff' },
  requestButton: {
    backgroundColor: '#fff',
    color: '#192c43',
    border: 'none',
    borderRadius: '6px',
    padding: '5px 10px',
    cursor: 'pointer',
    fontWeight: '600',
    transition: 'all 0.2s',
    
    fontFamily: `'Roboto Condensed', 'Kanit', sans-serif`,
  },
   modalOverlay: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100vw",
    height: "100vh",
    backgroundColor: "rgba(0, 0, 0, 0.5)", // ✅ สีดำโปร่ง
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 9999,
    backdropFilter: "blur(2px)", // เพิ่มความสวยละมุน
  },
  modalContent: {
    backgroundColor: "#fff",
    borderRadius: "16px",
    padding: "25px",
    width: "420px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
    position: "relative",
  },
  closeModal: {
    position: "absolute",
    top: "6vh",
    right: "6vh",
    border: "none",
    background: "transparent",
    fontSize: "1.5rem",
    cursor: "pointer",
    color: "#fff"
  },
};

export default PropertyListRent;
